// extracted by mini-css-extract-plugin
export default {"nearlyThere":"src-modules-registration-steps-account-style__nearlyThere_+yW0g","nearlyThereText":"src-modules-registration-steps-account-style__nearlyThereText_9fE17"};